/**
 * @generated SignedSource<<5f3cd62696066d7c9ebfe897502a8e2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StreamMeetingRecapSendTo = "ALL" | "INTERNAL" | "INTERNAL_ON_FELLOW" | "NONE";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type AutoShareRecapSettingsQuery$variables = {
  streamId: string;
};
export type AutoShareRecapSettingsQuery$data = {
  readonly noteStream: {
    readonly id: string;
    readonly meetingRecapAutoShareSource: {
      readonly __typename: "StreamMeetingRecapAutoShareSettings";
      readonly id: string;
      readonly sendTo_S: StreamMeetingRecapSendTo;
      readonly setBy: {
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
      };
    } | {
      readonly __typename: "UserMeetingRecapAutoShareSettings";
      readonly id: string;
      readonly sendTo_U: UserMeetingRecapSendTo;
      readonly user: {
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly meetingRecapAutoShareSourceIsFromOrganizer: boolean | null;
  } | null;
  readonly viewer: {
    readonly account: {
      readonly allowPublicRecap: boolean;
      readonly emailDomainList: ReadonlyArray<string>;
    };
    readonly id: string;
    readonly user: {
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
    };
  };
};
export type AutoShareRecapSettingsQuery = {
  response: AutoShareRecapSettingsQuery$data;
  variables: AutoShareRecapSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowPublicRecap",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecapAutoShareSourceIsFromOrganizer",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "sendTo_S",
      "args": null,
      "kind": "ScalarField",
      "name": "sendTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "setBy",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "StreamMeetingRecapAutoShareSettings",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "sendTo_U",
      "args": null,
      "kind": "ScalarField",
      "name": "sendTo",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "type": "UserMeetingRecapAutoShareSettings",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoShareRecapSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecapAutoShareSource",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoShareRecapSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecapAutoShareSource",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e60196573b9cd754d39b6784bd29314",
    "id": null,
    "metadata": {},
    "name": "AutoShareRecapSettingsQuery",
    "operationKind": "query",
    "text": "query AutoShareRecapSettingsQuery(\n  $streamId: ID!\n) {\n  viewer {\n    id\n    user {\n      id\n      fullName\n      firstName\n    }\n    account {\n      allowPublicRecap\n      emailDomainList\n      id\n    }\n  }\n  noteStream(id: $streamId) {\n    id\n    meetingRecapAutoShareSourceIsFromOrganizer\n    meetingRecapAutoShareSource {\n      __typename\n      ... on StreamMeetingRecapAutoShareSettings {\n        id\n        sendTo_S: sendTo\n        setBy {\n          id\n          fullName\n          firstName\n        }\n      }\n      ... on UserMeetingRecapAutoShareSettings {\n        id\n        sendTo_U: sendTo\n        user {\n          id\n          fullName\n          firstName\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba488806c2b20ba570210d499ccb8157";

export default node;
